module.exports = __webpack_public_path__ + "static/media/pe.23f4fbf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pe.svg
// module id = 219
// module chunks = 0